import { render, staticRenderFns } from "./powerGeneration.vue?vue&type=template&id=1d6cf2ab&scoped=true"
import script from "./powerGeneration.vue?vue&type=script&lang=js"
export * from "./powerGeneration.vue?vue&type=script&lang=js"
import style0 from "./powerGeneration.vue?vue&type=style&index=0&id=1d6cf2ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6cf2ab",
  null
  
)

export default component.exports